import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  HeroExpress,
  ConceptFrequency,
  Visibility360,
  MetricsExpress,
  InvestmentExpress,
  WinWinExpress,
  CampaignShine,
  CTAExpress,
} from './components';

const LandingMediaKitDanimarExpress = ({ themeMode = 'light' }) => {
  return (
    <Box>
      <Container>
        <HeroExpress themeMode={themeMode} />
      </Container>
      <Container>
        <ConceptFrequency />
      </Container>
      <Container>
        <Visibility360 />
      </Container>
      <Container>
        <MetricsExpress />
      </Container>
      <Container>
        <InvestmentExpress />
      </Container>
      <Container>
        <WinWinExpress />
      </Container>
      <Container>
        <CampaignShine />
      </Container>
      <Container>
        <CTAExpress />
      </Container>
    </Box>
  );
};

LandingMediaKitDanimarExpress.propTypes = {
  themeMode: PropTypes.string,
};

export default LandingMediaKitDanimarExpress;
